<div [routerLink]="['/board/', board._id]" class="container mt-5 mb-3 cursor">
    <div class="row">
        <div>
            <div class="card p-3 mb-2">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="icon"><img src="https://testfinanceplus.proventum.me/content/avatar/avatar_51.png">
                        </div>
                        <div class="ml-1 ms-2 c-details">
                            <h5 class="mb-0">{{board.projectData['name']}}</h5>
                            <span title="Datum kreiranja"><i class="lni lni-calendar"></i> {{dateCreated}}</span>
                        </div>
                    </div>
                    <div class="badge"><span>{{board.type}}</span></div>
                </div>
                <div class="mt-5">
                    <h3 class="heading board-name">{{board.name}}</h3>
                    <div class="mt-5">
                        <div class="progress">
                            <div class="board-card-progress-bar" role="progressbar"
                                 [ngStyle]="setStyles()"
                                 aria-valuenow="50"
                                 aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="mt-3"><span class="text1">Ukupno završenih {{doneTasksNumber}} <span
                                class="text2">od {{board.tasks.length}} </span></span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
